import { createFileRoute } from '@tanstack/react-router';
import Authorize from '@/features/authorize';

export const Route = createFileRoute('/_public/authorize/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <Authorize />;
}
